import 'trix/dist/trix.css'
import Trix from 'trix'

window.Trix = Trix
